import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import { PaymentMethod } from 'src/types';
import wallet from 'src/assets/images/wallet.png';
import { MoreMethods } from 'src/components/svg/Payments';

interface CardPaymentMethodProps {
  method: PaymentMethod;
  onClick?: (method: PaymentMethod) => void;
  selected?: boolean;
  id: string;
}

export const CardPaymentMethod = ({ method, onClick, selected, id }: CardPaymentMethodProps) => {
  const title = useMemo(() => {
    return method.title ? method.title : '';
  }, [method.title]);

  const handleClick = useCallback(() => {
    onClick?.(method);
  }, [method, onClick]);

  return (
    <div
      className={classNames(
        'rounded-[10px] relative w-[75px] border-2 border-solid border-[transparent]  412:w-[85px] min-h-[85px] flex flex-col items-center justify-center p-[15px] gap-1 bg-wdap_nodapay_method_bg',
        selected ? '!border-wdap_active_method_outline' : ''
      )}>
      <input
        type="radio"
        className="absolute w-[100%] h-[100%] top-0 left-0 opacity-0 cursor-pointer"
        id={id}
        name={id}
        value={id}
        onClick={handleClick}
      />
      {method.logoUrl ? (
        <img
          src={method.logoUrl}
          alt={title}
          className="max-w-[80px] object-contain h-9"
          onError={(event) => {
            const element = event.target as HTMLImageElement;
            element.src = wallet;
            element.classList.add('!max-w-[28px]');
            element.onerror = null;
          }}
        />
      ) : (
        <MoreMethods />
      )}
      <p
        className={classNames(
          'text-xs max-w-full text-center break-words break-all overflow-hidden inline-block text-ellipsis whitespace-nowrap',
          selected ? '!text-wdap_nodapay_method_selected_text' : 'text-wdap_nodapay_method_text'
        )}>
        {title}
      </p>
    </div>
  );
};
